import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { EcouponServiceService } from '../core/service/ecoupon-service.service';

export const ecouponOTPGuard: CanActivateFn = (route, state) => {
  const ecouponServiceService = inject(EcouponServiceService);
  const formData = ecouponServiceService.getDataFormSignal();
  return formData() ? true : false;
};
